function getProcessEnvVar (varName) {
  // Returns the value of a process.env var
  // Raise an error if the value is null, undefined or ''
  var v = process.env[varName];
  if (v === undefined || v === null || v === "") {
    throw new Error(varName + " not found in process.env");
  }
  return v;
}

const getHostname = (urlOrDomain) => {
  if (!urlOrDomain) {
    return '';
  }
  try {
    return new URL(String(urlOrDomain)).hostname.toLowerCase();
  } catch (e) {
    try {
      return new URL('http://' + String(urlOrDomain)).hostname.toLowerCase();
    } catch (e) {
      return '';
    }
  }
}

const getBaseWorkerHostname = (hostname) => {
  return String(hostname || '').replace(/-gw\d+(\.|$)/, '$1');
}

/**
 * Resolve the xdist worker workspace origin injected by Playwright.
 *
 * Account settings expose the canonical workspace domain, while parallel
 * browser tests must stay on the worker-specific nginx domain. This helper is
 * inert outside Playwright test contexts because the init-script globals are
 * absent in production.
 */
const getTestWorkspaceMonolithUrl = (domain) => {
  if (typeof window === 'undefined') {
    return null;
  }
  if (
    !window.__TEST_WORKSPACE_BASE_URL ||
    (!window.__TEST_RUN_ID && !window.__TEST_NODE_ID)
  ) {
    return null;
  }

  let testWorkspaceUrl = null;
  try {
    testWorkspaceUrl = new URL(String(window.__TEST_WORKSPACE_BASE_URL));
  } catch (e) {
    return null;
  }

  const requestedHostname = getHostname(domain);
  const workerHostname = testWorkspaceUrl.hostname.toLowerCase();
  const baseHostname = getBaseWorkerHostname(workerHostname);
  if (requestedHostname !== workerHostname && requestedHostname !== baseHostname) {
    return null;
  }

  return testWorkspaceUrl.origin;
}

const getMonolithUrl = (domain) => {
  const testWorkspaceUrl = getTestWorkspaceMonolithUrl(domain);
  if (testWorkspaceUrl) {
    return testWorkspaceUrl;
  }
  var ret = location.protocol + '//' + domain;
  return ret; 
}

const getSharedDataDomain = () => {
  return getProcessEnvVar('VUE_APP_SHARED_DATA_DOMAIN');
}

// const getWorkspaceDomainFromName = (workspace) => {
//   var varName = 'VUE_APP_KSEATING_WORKSPACE_DOMAIN_' + workspace.toUpperCase();
//   return getProcessEnvVar(varName);
// }

const isServerBackend = () => {
  return location.pathname.startsWith('/kmanage')
}

const protocol = location.protocol;

export {
  getMonolithUrl,
  getProcessEnvVar,
  getSharedDataDomain,
  // getWorkspaceDomainFromName,
  isServerBackend,
  protocol,
}
